import { defineLab, LAB_STATUS } from '@brightlocal/labs-sdk';

/**
 * Smoke-test lab for the Labs shell. The component is a dynamic import so the lab is its own chunk.
 * Dev-only: the host registers it in the `local` and `dev` environments alone. The pure mark lets
 * the bundler drop the manifest, and with it the chunk, from builds that never register it.
 */
export const helloLab = /* @__PURE__ */ defineLab({
  id: 'hello',
  title: 'Hello lab',
  description: 'A smoke test for the Labs shell: host context, tracking and the error boundary.',
  owner: 'frontend-platform',
  flag: 'labs-hello-allowed',
  status: LAB_STATUS.INTERNAL,
  sunset: '2027-01-31',
  scope: 'location',
  component: () => import('./HelloLab').then(({ HelloLab }) => ({ default: HelloLab }))
});
